"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var phocus_1 = require("phocus");
var action_1 = require("../action/action");
var phocus_context_1 = require("../phocus-context/phocus-context");
var phocus_button_1 = require("../phocus-button/phocus-button");
var phocus_modal_1 = require("../phocus-modal/phocus-modal");
var rebinding_modal_1 = require("./rebinding-modal");
var key_command_1 = require("./key-command");
phocus_1.ActionContextService.addContext("command-palette-action", {
    actions: {
        takeAction: new action_1.Action({
            name: "Take this action",
            shortDocumentation: "Take the action",
            actOn: function (c, _, e) {
                phocus_1.ActionContextService.triggerAction("closeModal");
                c.props.action.act(e);
            },
            defaultKeys: ["Enter"]
        }),
        rebind: new action_1.Action({
            name: "Edit Hotkey",
            shortDocumentation: "Rebind or alter the hotkey for this action",
            actOn: function (c, _, e) {
                if (e) {
                    e.stopPropagation();
                    e.preventDefault();
                }
                c.editHotkey();
            },
            defaultKeys: ["e"]
        }),
        next: new action_1.Action({
            name: "Next",
            defaultKeys: ["ArrowDown"],
            actOn: function (c) {
                phocus_1.focusInContext("action-" + (c.props.id + 1));
            }
        }),
        previous: new action_1.Action({
            name: "Previous",
            defaultKeys: ["ArrowUp"],
            actOn: function (c) {
                phocus_1.focusInContext("action-" + (c.props.id - 1));
            }
        })
    }
});
var CommandPaletteAction = /** @class */ (function (_super) {
    __extends(CommandPaletteAction, _super);
    function CommandPaletteAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hotkeyModalOpen: false
        };
        _this.cancelEdit = function () {
            _this.setState({ hotkeyModalOpen: false });
        };
        return _this;
    }
    CommandPaletteAction.prototype.editHotkey = function () {
        this.setState({ hotkeyModalOpen: true });
    };
    CommandPaletteAction.prototype.render = function () {
        return (React.createElement(phocus_context_1.PhocusContext, { context: "command-palette-action", argument: this },
            React.createElement("div", { className: "phocus-command-palette-action", "data-phocus-id": "action-" + this.props.id, "data-phocus-on-mouseover": true, "data-phocus-do-not-label": true, "data-phocus-action": "takeAction", role: "button", tabIndex: 0 },
                React.createElement("div", { className: "phocus-command-palette-action--name" }, this.props.action.action.name),
                React.createElement("div", { className: "phocus-command-palette-action--description" }, this.props.action.action.shortDocumentation),
                React.createElement(phocus_button_1.PhocusButton, { action: "rebind", className: "phocus-command-palette-action--key-command", doNotLabel: true },
                    React.createElement(key_command_1.KeyCommand, { action: this.props.action.action }))),
            this.state.hotkeyModalOpen && (React.createElement(phocus_modal_1.PhocusModal, { close: this.cancelEdit },
                React.createElement(rebinding_modal_1.RebindingModal, { action: this.props.action.action })))));
    };
    return CommandPaletteAction;
}(React.Component));
exports.CommandPaletteAction = CommandPaletteAction;
//# sourceMappingURL=command-palette-action.js.map